import {
  deleteAuthenticated,
  getAuthenticated,
  patchAuthenticated,
  postAuthenticated,
} from './http';

export const fetchShelfGames = ({
  limit = 24,
  page = 1,
  search = '',
  minPlayers = '',
  maxPlayers = '',
  maxTime = '',
  sort = 'name',
} = {}) =>
  getAuthenticated('/library', {
    params: {
      limit,
      page,
      search,
      minPlayers,
      maxPlayers,
      maxTime,
      sort,
    },
  });

export const fetchCompanionGames = ({
  limit = 8,
  page = 1,
  search = '',
  minPlayers = '',
  maxPlayers = '',
  maxTime = '',
  sort = 'name',
} = {}) =>
  getAuthenticated('/library/friends', {
    params: {
      limit,
      page,
      search,
      minPlayers,
      maxPlayers,
      maxTime,
      sort,
    },
  });

export const addShelfGame = (game) => postAuthenticated('/library', game);

export const updateShelfGame = (id, values) =>
  patchAuthenticated(`/library/${id}`, values);

export const deleteShelfGame = (id) => deleteAuthenticated(`/library/${id}`);
